import './index.css'

const NoPasswordsView = () => (
  <div className="no-pass-view-container">
    <img
      className="no-pass-view-img"
      src="https://assets.ccbp.in/frontend/react-js/no-passwords-img.png"
      alt="no passwords"
    />
    <p className="no-pass-text">No Passwords</p>
  </div>
)

export default NoPasswordsView
